import { render } from "./AMLCheck.vue?vue&type=template&id=2315733a&scoped=true"
import script from "./AMLCheck.vue?vue&type=script&lang=js"
export * from "./AMLCheck.vue?vue&type=script&lang=js"

import "./AMLCheck.vue?vue&type=style&index=0&id=2315733a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2315733a"]])

export default __exports__